<template>
  <a-row :gutter="16">
    <div class="template-edit-component">
      <a-form :form="form">
        <a-col span="14">
          <div class="panel panel-default panel-stretch">
            <div class="panel-heading">
              Templategegevens
            </div>
            <div class="panel-body">
              <a-form-item v-if="selectedType !== 3" v-bind="formItemLayout" label="Type"
                           :validate-status="errors && errors.hasOwnProperty('type') ? 'error' : undefined"
                           :help="errors && errors.hasOwnProperty('type') ? errors.type : undefined"
              >
                <a-radio-group @change="handleTypeChange" id="type" buttonStyle="solid"
                               v-decorator="[
                                                    'type',
                                                    {
                                                      initialValue: template.type,
                                                      rules: [{
                                                        required: true,
                                                        message: 'Dit veld is verplicht',
                                                      }],
                                                    }
                                                  ]">
                  <a-radio-button :value="2">
                    E-mail
                  </a-radio-button>
                  <a-radio-button :value="1">
                    Brief
                  </a-radio-button>
                </a-radio-group>
              </a-form-item>
              <a-form-item v-if="selectedType !== 3" v-bind="formItemLayout" label="Categorie"
                           :validate-status="errors && errors.hasOwnProperty('category') ? 'error' : undefined"
                           :help="errors && errors.hasOwnProperty('category') ? errors.category : undefined"

              >
                <a-select @change="onCategoryChange"
                          v-decorator="[
                                                'category',
                                                {
                                                  initialValue: typeof template.category !== 'undefined' ? template.category : 1,
                                                  rules: [{
                                                    required: true,
                                                    message: 'Dit veld is verplicht',
                                                  }],
                                                }
                                              ]"
                          :filter-option="filter"
                          show-search
                          :options="getTemplateCategories"
                ></a-select>
              </a-form-item>

              <a-form-item v-if="selectedType !== 3" v-bind="formItemLayout" label="Naam in systeem"
                           :validate-status="errors && errors.hasOwnProperty('nameInSystem') ? 'error' : undefined"
                           :help="errors && errors.hasOwnProperty('nameInSystem') ? errors.nameInSystem : undefined"
              >
                <a-input @focus="onBasicInputFocus"
                         v-decorator="[
                                              'nameInSystem',
                                              {
                                              initialValue: template.nameInSystem,
                                                rules: [{
                                                  required: true,
                                                  message: 'Dit veld is verplicht',
                                                }]
                                              }
                                            ]"
                />
              </a-form-item>
              <a-form-item v-if="selectedType !== 3" v-bind="formItemLayout" label="Standaard onderwerp"
                           :validate-status="errors && errors.hasOwnProperty('title') ? 'error' : undefined"
                           :help="errors && errors.hasOwnProperty('title') ? errors.title : undefined"
              >
                <a-input @focus="onBasicInputFocus" v-decorator="[
                                    'title',
                                    {
                                        initialValue: template.title
                                    }]"/>
              </a-form-item>

              <a-form-item v-if="selectedType === 2" v-bind="formItemLayout" label="Html template">
                <a-select
                    @change="handelHtmlEmailTemplateChange"
                    v-decorator="[
                      'html_email_template_id',
                      {
                        initialValue: template.html_email_template_id,
                      }
                    ]"
                >
                  <a-select-option
                      v-for="htmlTemplate in htmlEmailTemplates"
                      :key="htmlTemplate.id"
                      :value="htmlTemplate.id"
                  >{{ htmlTemplate.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-model-item v-bind="formItemLayout" v-if="hasTemplateSelected" label="Voorbeeld">
                <a-switch v-model="showHtmlTemplateExample"/>
                <HtmlTemplateExampleComponent v-if="showHtmlTemplateExample" :template-content="selectedHtmlTemplateContent"/>
              </a-form-model-item>


              <a-tabs type="card" :default-active-key="activeTabPane">
                <a-tab-pane tab="Maatschappij" key="agency" ref="agency_tab">
                  <a-form-item v-if="selectedType !== 3" v-bind="formItemLayout" label="Standaard e-mailadres"
                               :validate-status="errors && errors.hasOwnProperty('agency') ? 'error' : undefined"
                               :help="errors && errors.hasOwnProperty('agency') ? errors.agency : undefined"
                  >
                    <a-select id="agency" @change="onAgencyChange" v-decorator="['agency',
                                            {
                                                initialValue: template.agency_id
                                            }]">
                      <a-select-option
                          v-for="agency in agencies"
                          :key="agency.id"
                          :value="agency.id"
                      >{{ agency.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-form-item v-bind="formItemLayout" label="E-mailadres"
                               :validate-status="errors && errors.hasOwnProperty('employees') ? 'error' : undefined"
                               :help="errors && errors.hasOwnProperty('employees') ? errors.employees : undefined"
                  >
                    <a-select id="employee" mode="multiple" v-decorator="[
                                            'employees',
                                            {
                                        initialValue: employeesInitialValue
                                            }]">
                      <a-select-opt-group
                          v-for="department in departments"
                          :key="department.id"
                      >
                        <span slot="label">{{ department.name }}</span>
                        <a-select-option
                            v-for="employee in department.employees.data"
                            :key="employee.id"
                            :value="employee.id"
                        >
                          {{ employee.emailaddress }}
                        </a-select-option>
                      </a-select-opt-group>
                    </a-select>
                  </a-form-item>
                </a-tab-pane>
                <a-tab-pane tab="Zelf invoeren" key="custom">
                  <a-form-item v-bind="formItemLayout" label="Standaard e-mailadres"
                               :validate-status="errors && errors.hasOwnProperty('primaryMail') ? 'error' : undefined"
                               :help="errors && errors.hasOwnProperty('primaryMail') ? errors.primaryMail : undefined"
                  >
                    <a-input @focus="onBasicInputFocus" v-decorator="[
                                            'primaryMail',
                                            {
                                            initialValue: template.primaryMail
                                            }
                                            ]"/>
                  </a-form-item>
                  <a-form-item v-bind="formItemLayout" label="Cc"
                               :validate-status="errors && errors.hasOwnProperty('email_cc') ? 'error' : undefined"
                               :help="errors && errors.hasOwnProperty('email_cc') ? errors.email_cc : undefined"
                  >
                    <a-input @focus="onBasicInputFocus" v-decorator="[
                                            'email_cc',
                                            {
                                            initialValue: template.email_cc
                                            }
                                            ]"/>
                  </a-form-item>
                  <a-form-item v-bind="formItemLayout" label="Bcc"
                               :validate-status="errors && errors.hasOwnProperty('email_bcc') ? 'error' : undefined"
                               :help="errors && errors.hasOwnProperty('email_bcc') ? errors.email_bcc : undefined"
                  >
                    <a-input @focus="onBasicInputFocus" v-decorator="[
                                            'email_bcc',
                                            {
                                            initialValue: template.email_bcc
                                            }
                                            ]"/>
                  </a-form-item>
                </a-tab-pane>
              </a-tabs>
            </div>
            <div class="panel-footer text-right">
              <a-button type="primary" @click="onSubmit">Opslaan</a-button>
            </div>
          </div>
          <div class="panel panel-default panel-stretch">
            <div class="panel-heading">
              INHOUD
            </div>
            <div class="panel-body no-padding">
              <a-form-item
                  :validate-status="errors && errors.hasOwnProperty('content') ? 'error' : undefined"
                  :help="errors && errors.hasOwnProperty('content') ? errors.content : undefined"
              >
                <froala :tag="'textarea'" :config="froalaConfig"
                        v-decorator="['content', {initialValue: template.content}]"
                        ref="froala"

                >
                </froala>
              </a-form-item>
            </div>
            <div class="panel-footer text-right">
              <a-button type="primary" @click="onSubmit">Opslaan</a-button>
            </div>
          </div>
        </a-col>
      </a-form>
      <a-col span="10">
        <a-row>
          <div class="panel panel-default panel-stretch">
            <div class="panel-heading">
              DATA CATEGORIEËN
            </div>
            <div class="panel-body">
              <p>Altijd aanwezig</p>
              <content-loader v-if="!hasStaticDefinition"
                              :width="500"
                              :height="146"
                              :speed="2"
                              :animate="true"
                              primaryColor="#f3f3f3"
                              secondaryColor="#ecebeb"
                              style="max-width:500px;">
                <rect x="0" y="0" rx="0" ry="0" width="500" height="68"/>
                <rect x="0" y="73" rx="0" ry="0" width="500" height="68"/>
              </content-loader>
              <div v-else>
                <DefinitionComponent v-for="staticTemplateDefinition in staticTemplateDefinitions"
                                     :key="staticTemplateDefinition.class"
                                     :definition="staticTemplateDefinition"
                                     :display-relations-initially="false"
                                     @selectDefinition="onSelectedDefinition"></DefinitionComponent>
              </div>
            </div>
            <div class="panel-body">
              <p>Dynamische onderdelen (afhankelijk van categorie)</p>
              <content-loader v-if="!hasSourceDefinition"
                              :width="500"
                              :height="146"
                              :speed="2"
                              :animate="true"
                              primaryColor="#f3f3f3"
                              secondaryColor="#ecebeb"
                              style="max-width:500px;">
                <rect x="0" y="0" rx="0" ry="0" width="500" height="68"/>
                <rect x="0" y="73" rx="0" ry="0" width="500" height="68"/>
              </content-loader>
              <div v-else>
                <DefinitionComponent :definition="sourceTemplateDefinition"
                                     @selectDefinition="onSelectedDefinition"></DefinitionComponent>
              </div>
            </div>
          </div>
          <div v-if="selectedTemplatingDefinition !== null" class="panel panel-default panel-stretch">
            <div class="panel-heading">
              DATA VELDEN
            </div>
            <div class="panel-body">
              <a-input-search
                  placeholder="Zoeken"
                  @change="onSearchTemplateAttribute"
              />
              <div>
                <ValueComponent v-for="value in definitionValues"
                                :key="value.key"
                                :definition="selectedTemplatingDefinition"
                                :value="value"
                                :helpMessage="valueComponentTooltip"
                                @selectAttribute="onSelectedAttribute">
                </ValueComponent>
              </div>
            </div>
          </div>
        </a-row>
      </a-col>
    </div>
  </a-row>
</template>

<script>
import {mapGetters} from "vuex";
import store from '../store';
import templatingApi from '~/api/templating';
import templateApi from '~/api/template';
import categoryApi from '~/api/category';
import agencyApi from '~/api/agency';
import htmlEmailTemplateApi from '~/api/html_email_template';
import DefinitionComponent from "~/modules/templating/components/DefinitionComponent";
import ValueComponent from "~/modules/templating/components/ValueComponent";
import VueFroala from 'vue-froala-wysiwyg';
import {ContentLoader} from 'vue-content-loader';
import HtmlTemplateExampleComponent from '~/modules/html_email_template/components/ExampleComponent.vue';

const escapeStringRegexp = require('escape-string-regexp');

export default {
  name: "TemplateEditComponent",
  props: {
    templateId: { type: [String, Number]},
    redirectUri: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      staticTemplateDefinitions: [],
      sourceTemplateDefinition: null,
      templateCategories: [],
      lastFocusedBasicInput: null,
      agencies: [],
      editor: null,
      attributeSearch: '',
      froalaConfig: {
        key: window.state.froala_key,
        events: {
          'focus': this.onFroalaFocus.bind(this),
          'blur': this.saveFroalaCaretPosition.bind(this),
          'click': this.saveFroalaCaretPosition.bind(this),
          'input': this.saveFroalaCaretPosition.bind(this),
          'keyup': this.onFroalaKeyUp.bind(this),
        },
        pastePlain: true,
        imagePaste: false,
        htmlRemoveTags: ['script', 'style', 'img'],
        pasteDeniedAttrs: ['id'],
        pluginsEnabled: [
          'align', 'colors', 'fontFamily', 'fontSize', 'lineHeight', 'link', 'lists', 'quote', 'table', 'url', 'wordPaste',
        ],
      },
      formItemLayout: {
        labelCol: {span: 6},
        wrapperCol: {span: 14},
      },
      form: this.$form.createForm(this),
      valueComponentTooltip: "Zet de cursor op de juiste plaats in de template. Klik vervolgens op het dataveld dat u toe wilt voegen",
      htmlEmailTemplates: [],
      selectedHtmlTemplate: undefined,
      selectedType: undefined,
      showHtmlTemplateExample: false,
      template: {
        agency_id: null,
        content: "",
        category: null,
        type: 1,
        agency: {
          data: null,
        }
      },
      errors: {}
    }
  },
  computed: {
    ...mapGetters({}),
    hasDefinition() {
      return this.hasStaticDefinition || this.hasSourceDefinition;
    },
    hasStaticDefinition() {
      return this.staticTemplateDefinitions.length > 0;
    },
    hasSourceDefinition() {
      return this.sourceTemplateDefinition !== null;
    },
    selectedTemplatingDefinition() {
      return store.state.selectedDefinition;
    },
    departments() {
      if (
          typeof this.template.agency !== "undefined"
          && typeof this.template.agency.data !== "undefined"
          && this.template.agency.data !== null
          && typeof this.template.agency.data.departments !== "undefined"
      ) {
        return this.template.agency.data.departments.data;
      }
      return [];
    },
    activeTabPane() {
      if (this.exists(this.template.agency_id)) {
        return 'agency';
      } else {
        return 'custom';
      }
    },
    definitionValues() {
      let attributes, computedAttributes;
      if (this.attributeSearch.length > 0) {
        attributes = this.selectedTemplatingDefinition.attributes.data.filter((attribute) => {
          return attribute.name.match(this.attributeSearch)
              || attribute.key.match(this.attributeSearch);
        });
        computedAttributes = this.selectedTemplatingDefinition.computed_attributes.data.filter((attribute) => {
          return attribute.name.match(this.attributeSearch)
              || attribute.key.match(this.attributeSearch);
        });
      } else if (this.selectedTemplatingDefinition !== null) {
        attributes = this.selectedTemplatingDefinition.attributes.data;
        computedAttributes = this.selectedTemplatingDefinition.computed_attributes.data;
      } else {
        return [];
      }

      return attributes.concat(computedAttributes);
    },
    shouldCreate() {
      return !this.exists(this.template.id);
    },
    employeesInitialValue() {
      if (this.exists(this.template.employees)) {
        return this.template.employees.data.map(employee => employee.id);
      }
    },
    hasTemplateSelected() {
      return typeof this.selectedHtmlTemplate !== 'undefined'
          && this.selectedHtmlTemplate !== null
          && this.selectedType === 2
    },
    getTemplateCategories() {
      return this.templateCategories.map(template => {
        return {
          'value': template.id,
          'label': template.name,
          'options': {
            'name': template.name
          }
        }
      })
    },
    selectedHtmlTemplateContent() {
      if (this.selectedType === 2 && this.selectedHtmlTemplate !== null) {
        let htmlTemplate = this.htmlEmailTemplates.filter(template => {
          return template.id === this.selectedHtmlTemplate
        })[0]

        if (typeof htmlTemplate !== 'undefined' && htmlTemplate !== null) {
          return htmlTemplate.content
        }
      }

      return '<h6>Er is geen html template geselecteerd of er ging iets mis met het renderen hiervan</h6>'
    }
  },
  created() {
    const STORE_KEY = '$_templating';
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  },
  mounted() {
    this.fetchStaticTemplatingDefinitions();
    // this fetches the dynamic templating definitions with the same category fallback as the template category select
    this.onCategoryChange(this.template.category ?? 1)

    if ( this.templateId ){
      templateApi.getTemplateById(this.templateId).then(({ data }) => {
        this.template = data;
        this.selectedHtmlTemplate = this.template.html_email_template_id;
        this.selectedType = this.template.type;
      }).catch(function (error) {

      });
    }

    categoryApi.getCategories().then((response) => {
      this.templateCategories = response.data.filter(category => category.name !== "Mailing");
    }).catch();

    agencyApi.allWithEmployees()
        .then(response => {
          this.agencies = response.data;
        })
        .catch();

    htmlEmailTemplateApi.paginate(1, 50)
        .then(response => {
          this.htmlEmailTemplates = response.data;
        });

    this.editor = this.$refs.froala.getEditor();
  },
  components: {
    DefinitionComponent,
    ValueComponent,
    ContentLoader,
    VueFroala,
    HtmlTemplateExampleComponent
  },
  methods: {
    handleTypeChange(event) {
      this.selectedType = event.target.value
      if (event.target.value === 1) {
        this.selectedHtmlTemplate = 0
      }
    },
    handelHtmlEmailTemplateChange(value) {
      this.selectedHtmlTemplate = value
    },
    onBasicInputFocus(e) {
      this.lastFocusedBasicInput = e.target;
    },
    onFroalaFocus(e) {
      this.saveFroalaCaretPosition();
      this.lastFocusedBasicInput = null;
    },
    saveFroalaCaretPosition() {
      this.editor.selection.save();
      let parentNode = this.editor.selection.element().parentNode;
      if (parentNode.classList.contains('non-editable')) {
        parentNode.classList.add('focused');
      } else {
        let focusedElements = document.getElementsByClassName('focused');
        for (let i = 0; i < focusedElements.length; i++) {
          focusedElements[i].classList.remove('focused');
        }
      }
    },
    onSearchTemplateAttribute(e) {
      this.attributeSearch = escapeStringRegexp(e.target.value);
    },
    onFroalaKeyUp(e) {
      let element = this.editor.selection.element();
      if (this.exists(element) && element.classList.contains('non-editable')
          && (e.key === 'Backspace' || e.key === 'Delete')
      ) {
        element.parentNode.removeChild(element);
      }
    },
    selectDefinition() {
      this.$emit('selectDefinition', this.definition, this.parentDefinition);
    },
    setSourceTemplateDefinition(templateDefinition) {
      this.sourceTemplateDefinition = templateDefinition;
    },
    fetchStaticTemplatingDefinitions() {
      templatingApi.getGeneralDefinition()
          .then((response) => {
            this.staticTemplateDefinitions.push(response.data);
          }).catch(function (error) {
      });
      templatingApi.getDefinitionByClass("App\\Models\\User")
        .then((response) => {
          this.staticTemplateDefinitions.push(response.data);
        })
        .catch(function(error) {
        });
      templatingApi.getDefinitionByClass('App\\Models\\Customer')
          .then((response) => {
            this.staticTemplateDefinitions.push(response.data);
          }).catch(function (error) {
      });
    },
    fetchTemplatingDefinitionByTemplateCategory() {
      if (this.template.category !== null) {
        templatingApi.getDefinitionByCategoryId(this.template.category)
            .then((response) => {
              this.setSourceTemplateDefinition(response.data);
            }).catch(function (error) {
        })
      }
    },
    onCategoryChange(value) {
      this.template = {...this.template, category: value};
      this.fetchTemplatingDefinitionByTemplateCategory();
      this.definitionValues = [];
    },
    onAgencyChange(value) {
      this.template.agency = {};
      this.template.agency.data = this.agencies.filter((agency) => {
        return agency.id === parseInt(value);
      })[0];
    },
    onSelectedDefinition(templateDefinition) {
      store.state.selectedDefinition = templateDefinition;
      this.attributeSearch = '';
    },
    onSelectedAttribute(attribute) {
      let selection = store.state.selection;
      selection.push(attribute);
      this.$store.dispatch('$_templating/getSelection', selection);

      if (this.lastFocusedBasicInput === null) {
        this.editor.selection.restore();
        let element = this.editor.selection.element();
        if (this.exists(element) && element.classList.contains('non-editable')) {
          this.editor.selection.setAfter(element);
          this.editor.selection.restore();
        }
        this.editor.html.insert('<span>&nbsp;</span><span class="non-editable fr-deletable" contenteditable="false">{' + attribute.key + '}</span><span>&nbsp;</span>');
        this.editor.selection.save();
      } else {
        this.lastFocusedBasicInput.focus();
        this.lastFocusedBasicInput.value = '{' + attribute.key + '}';
      }

    },
    isAgencyTabSelected() {
      return this.$refs.agency_tab?.active;
    },
    filter(value,option) {
      return option.data.props.options.name.toLowerCase().includes(value.toLowerCase())
    },
    async onSubmit(e) {
      this.form.validateFields(async (err, values) => {
        if (this.exists(this.template.id)) {
          values.id = this.template.id;
        }
        if ( this.template.type === 3 ){
          //complement data from hidden elements by template
          values.type = this.template.type;
          if ( !values.category ) values.category = this.template.category;
          if ( !values.nameInSystem ) values.nameInSystem = this.template.nameInSystem;
        }
        if (this.isAgencyTabSelected()) {
          delete values.primaryMail;
          delete values.email_cc;
          delete values.email_bcc;
        } else {
          delete values.employees;
          delete values.agency_id;
        }
        values.content = this.editor.html.get();
        if (!err) {
          try {
            await templateApi[this.shouldCreate ? 'storeTemplate' : 'updateTemplate'](values);

            window.location = this.redirectUri;
          } catch (e) {
            if (e.response.status === 400) {
              this.$notification['error']({
                message: 'Validatie mislukt', //'Validation failed',
                description: 'Sommige velden zijn niet gevuld of incorrect', //'Some required fields are missing or incorrect'
              });
            } else if (e.response.status === 500) {
              this.$notification['error']({
                message: 'Er is iets fout gegaan',//'Something went wrong',
                description: 'Probeer het later nogmaals', //'Something went wrong'
              });
            } else if (e.response.status === 422) {
              this.$notification['error']({
                message: 'Sommige velden zijn unjuist ingevuld',//'Something went wrong',
                description: 'Probeer het nogmaals', //'Something went wrong'
              });
              this.errors = e.response.data.error.errors
            } else {
              this.$notification['error']({
                message: 'Onbekende fout', //'Unknown error',
                description: 'Er is een onbekende fout opgetreden',//'Unknown error'
              });
            }
          }
        }
      });
    },

    exists(load) {
      if (load !== undefined && load !== null) {
        return true
      }
      return false
    }
  }
}
</script>
<style module>
.fr-box .fr-view [contenteditable="false"] {
  display: inline-block;
  margin: 0 .2rem 0;
  border-radius: 0;
  padding: 2px;
  color: white;
  font-family: "Courier New", Courier, monospace;
  background-color: #0090CA;
}

.fr-box .fr-view [contenteditable="false"].focused {
  outline: 2px solid #2d8ac7;
}

.fr-box .fr-toolbar {
  border: none;
  border-bottom: solid 1px #ccc;
}

.fr-box.fr-basic .fr-wrapper {
  border: none;
}

.fr-box .second-toolbar {
  display: none;
}

.ant-form-item {
  margin-bottom: 4px;
}
</style>
<style scoped>
.definition {
  border: solid 1px #ccc;
  border-radius: .5rem;
  padding: 1.5rem 1rem;
  cursor: pointer;
}

.definition.active {
  background-color: #1a8ffc;
  color: white;
  border: solid 1px #0479e7;
  cursor: default;
}

.definition:not(.active):hover {
  background-color: #f1f1f1;
}

.relations {
  padding: 1rem 1.5rem;
}

.relations .item {
  margin-bottom: .5rem;
}

.email_recipient_tabs {
  width: 100%
}
</style>
